module.exports = __webpack_public_path__ + "media/images/windows_download_logo_135px-509a3163.png";